import "moment-timezone";
import IconBool from "components/IconBool";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableConfig = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const stickyCellStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "169px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "32px",
                            verticalAlign: "bottom",
                            ...stickyCellStyle,
                        }}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.id} data-idx={item.id} onChange={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxOpModes"
                                    key={item.id}
                                    data-idx={item.id}
                                    defaultChecked={items.current.chosen.includes(item.id)}
                                    readOnly={true}
                                />
                            </td>
                            <td>{item.name}</td>
                            <td className="text-center">
                                <IconBool value={item.default} />
                            </td>
                            <td>{item.model}</td>
                            <td>{item.ships_name}</td>
                            <td>{item.sensors_name}</td>
                            <td>{item.alerts_name}</td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};

export default TableConfig;
